import { useContext, useCallback, useEffect} from 'react';
import { Container, Row} from "react-bootstrap";
import { Web3ModalContext } from "contexts/Web3ModalProvider";
import { NotificationManager } from 'react-notifications';
import { defaultChainId, networkNames } from "blockchain/constants";
import Main from "../Main";
import Logo from "assets/logo.png";

import React from "react";
import Unity, { UnityContext } from "react-unity-webgl";


const unityContext = new UnityContext({
  loaderUrl: "Build/webgl.loader.js",
  dataUrl: "Build/webgl.data",
  frameworkUrl: "Build/webgl.framework.js",
  codeUrl: "Build/webgl.wasm"
});

const ComingSoon = () => {

  return <></>;
}



<script></script>
export default ComingSoon;

